import axios from 'axios';
import { REVIEWURL } from '../index';

export const getReviewApi = (postData) => {
  return axios.post(REVIEWURL, JSON.stringify(postData));
};
